// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
class _ScrollUtils {
    IsScrollUp(deltaY) {
        if (deltaY < 0) {
            return true;
        }
        return false;
    }
    IsScrollDown(deltaY) {
        if (deltaY > 0) {
            return true;
        }
        return false;
    }
}
export const ScrollUtils = new _ScrollUtils();
